import { useModal, create } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { ProfileCompletedActionSheetController } from './profile-completed-action-sheet.controller';

const ProfileCompletedActionSheetModal = create(ProfileCompletedActionSheetController);

export const useProfileCompletedActionSheet = () => {
  const { show } = useModal(ProfileCompletedActionSheetModal);
  return useMemo(() => ({ open: show }), [show]);
};
